import { BusinessApi } from 'shared/api';
import { ICreateOwnerDto } from 'shared/api/business/interfaces/create-owner-dto.interface';

export const signUpOwner = (
  email: string,
  fio: string,
  phone: string,
  password: string
) => {
  const dto: ICreateOwnerDto = {
    email: email,
    fio: fio,
    phone: phone,
    password: password,
  };
  return BusinessApi.createOwner(dto);
};
